import { render } from "./Notes9.vue?vue&type=template&id=55aaa65a&scoped=true"
import script from "./Notes9.vue?vue&type=script&lang=js"
export * from "./Notes9.vue?vue&type=script&lang=js"

import "./Notes9.vue?vue&type=style&index=0&id=55aaa65a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55aaa65a"]])

export default __exports__